import { useQueryState } from "context/queryState"

import styled from "styled-components"

import { WEBHOOK } from "reducers/webhook/webhook-actions"
import ApiWebhook from "api/ApiWebhook"
import WebhookList from "./components/WebhookList"
import { useState } from "react"
import WebhookHeader from "./components/WebhookHeader"
import { useAppSelector } from "reducers/store"

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${(props) => props.theme.palette.gray_ice};
  margin-top: 48px;
  gap: 32px;
  overflow: hidden;
`
const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
`

const Webhook = () => {
  const [filterValue, setFilterValue] = useState<string>("")

  useQueryState([WEBHOOK, filterValue], async () => await new ApiWebhook().getAll(filterValue), WEBHOOK, {
    refetchOnMount: "always"
  })

  const { data } = useAppSelector((state) => state.webhook.webhookList)

  return (
    <Container>
      <InnerContainer>
        <WebhookHeader hasData={!!data.length} filterValue={filterValue} setFilterValue={setFilterValue} />
        <WebhookList hasData={!!data.length} />
      </InnerContainer>
    </Container>
  )
}

export default Webhook
